import { dynamicFailed } from "../hooks/useToast";
import { ICategory, IModules, IRole } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchDropdownCategories = async (): Promise<ICategory[]> => {
  try {
    const response = await axiosClient.get<ICategory[]>("/options/categories");
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};

export const fetchStatusManagementOption = async (): Promise<IModules[]> => {
  try {
    const response = await axiosClient.get<IModules[]>("/options/modules");
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};

export const fetchRoles = async (): Promise<IRole[]> => {
  try {
    const response = await axiosClient.get<IRole[]>("/options/roles");
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};
